import script from "./UpCarTiaero.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpCarTiaero.vue?vue&type=script&lang=ts&setup=true"

import "./UpCarTiaero.vue?vue&type=style&index=0&id=86efd0f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86efd0f8"]])

export default __exports__